import { useGetBonusGroup } from '@/query/queries/marketing/useGetBonusGroup';
import { LAYOUT_TYPE } from './constants';
import { EveryFiveGroupA } from './index';

export const useEveryFiveGroupA = ({
  amount,
  bonusAmount,
  layout = LAYOUT_TYPE.investing_slider_card,
}) => {
  const { data } = useGetBonusGroup();

  if (!data) return null;

  return (
    <EveryFiveGroupA
      data={data}
      layout={layout}
      bonusAmount={bonusAmount}
      amount={amount}
    />
  );
};
